class I18n {
    constructor() {
        this.translations = this.getLangPack()
        this.defaultLang = 'de'
        this.lang = document.documentElement.lang.toLowerCase().slice(0, 2);
    }

    t(key) {
        return this.translations[this.lang][key] || this.translations[this.defaultLang][key]
    }

    getLangPack() {
        return {
            de: {
                embeddedPostsTitle: 'Externe Inhalte',
                embeddedPostsBody: 'Möchtest du diesen ergänzenden Inhalt (Video, Instagram etc.) sehen? Falls du damit einverstanden bist, dass Cookies gesetzt und dadurch Daten an externe Anbieter übermittelt werden, kannst du alle Cookies zulassen und externe Inhalte direkt anzeigen lassen.',
                embeddedPostsButton: 'Externe Inhalte laden',
                embeddedPostsMoreInfos: 'Mehr Infos'
            },
            fr: {
                embeddedPostsTitle: 'Contenus externes',
                embeddedPostsBody: 'Voulez-vous voir ce contenu complémentaire (vidéo, Instagram, etc.) ? Si vous acceptez que des cookies soient installés et que des données soient transmises à des fournisseurs externes, vous pouvez autoriser tous les cookies et afficher directement les contenus externes.',
                embeddedPostsButton: 'Charger les contenus externes',
                embeddedPostsMoreInfos: 'Plus d’infos'
            },
            it: {
                embeddedPostsTitle: 'Contenuti esterni',
                embeddedPostsBody: 'Vuoi vedere questo contenuto aggiuntivo (video, Instagram ecc.)? Se accetti che vengano impostati dei cookie e che i dati vengano trasmessi a fornitori esterni, puoi consentire tutti i cookie e visualizzare direttamente i contenuti esterni.',
                embeddedPostsButton: 'Carica contenuti esterni',
                embeddedPostsMoreInfos: 'Maggiori informazioni'
            }
        }
    }

}

export default I18n